import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { RutaCriticaService } from './services/ruta-critica.service';
import { IGetActividadesRequest, IGetActividadesResponse } from './interfaces/ruta-critica.interface';
import { MessageService } from 'primeng/api';
import { ActividadFormDialogComponent } from './actividad-form-dialog.component';

interface Actividad {
  actividad: string;
  descripcion: string;
  dependencia: string;
  tipo: string;
}

@Component({
  selector: 'app-actividades-dialog',
  templateUrl: './actividades-dialog.component.html',
  providers: [MessageService]
})
export class ActividadesDialogComponent implements OnInit {
  proceso: number = 0;
  actividades: Actividad[] = [];
  loading: boolean = false;
  globalFilter: string = '';
  first: number = 0;
  rows: number = 20;
  totalRecords: number = 0;
  displayFormDialog: boolean = false;
  selectedActividad: any = null;

  displayedColumns = [
    { field: 'actividad', header: 'Actividad' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'dependencia', header: 'Dependencia' },
    { field: 'tipo', header: 'Tipo' },
    { field: 'acciones', header: 'Acciones' }
  ];

  constructor(
    private dialogRef: MatDialogRef<ActividadesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private rutaCriticaService: RutaCriticaService,
    private messageService: MessageService,
    private dialog: MatDialog
  ) {
    this.proceso = data?.proceso ?? 0;
  }

  ngOnInit(): void {
    this.cargarActividades();
  }

  cargarActividades() {
    this.loading = true;
    const request: IGetActividadesRequest = {
      tope: '999',
      numero_proceso: this.proceso,
      numero_actividad: 0,
      descripcion: '',
      tipo_actividad: '',
      dependencia: '',
      tiempo_estimado: 0,
      dias_semana: '',
      horas: 0,
      minutos: 0,
      horas_dia: '',
      costo_estimado: 0,
      marcaje_automatico: '',
      envio_carta: '',
      procesoAutomatico: '',
      cuentaCredito: '',
      accion: '',
      resultado: '',
      responsable: '',
      carta: '',
      encuesta: '',
      decisiones: ''
    };
    this.rutaCriticaService.getActividades(request).subscribe({
      next: (res: IGetActividadesResponse) => {
        if (res.success) {
          this.actividades = res.data.map(a => ({
            actividad: String(a.numero_actividad),
            descripcion: a.descripcion,
            dependencia: a.dependencia,
            tipo: a.tipo_actividad
          }));
          this.totalRecords = this.actividades.length;
        } else {
          this.actividades = [];
          this.totalRecords = 0;
        }
      },
      complete: () => this.loading = false
    });
  }

  onDialogClosed() {
    this.dialogRef.close();
  }

  openCreate() {
    this.selectedActividad = null;
    this.displayFormDialog = true;
  }

  openEdit(row: any) {
    this.selectedActividad = {
      numero_actividad: row.actividad
    };
    this.displayFormDialog = true;
  }

  onFormDialogClosed(event?: { refresh: boolean, success: boolean, message: string }) {
    this.displayFormDialog = false;
    this.selectedActividad = null;
    if (event?.refresh) {
      this.cargarActividades();
    }
    if (event?.message) {
      this.messageService.add({
        severity: event.success ? 'success' : 'error',
        summary: event.success ? 'Éxito' : 'Error',
        detail: event.message
      });
    }
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
  }

  onFilter(event: any): void {
    this.globalFilter = event.target.value;
  }

  delete(row: any) {
    import('sweetalert2').then(Swal => {
      Swal.default.fire({
        title: '¿Está seguro?',
        text: `¿Está seguro de eliminar la actividad?`,
        icon: 'warning',
        showCancelButton: true,
        iconColor: "#d33",
        confirmButtonColor: "#d33",
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'No',
        heightAuto: false
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.loading = true;
          const request = {
            que: 3,
            numeroProceso: this.proceso,
            numeroActividad: row.actividad,
            descripcion: '',
            tipoActividad: '',
            dependencia: '',
            tiempoEstimado: 0,
            diasSemana: '',
            horas: 0,
            minutos: 0,
            horasDia: '',
            costoEstimado: 0,
            marcajeAutomatico: '',
            envioCarta: '',
            procesoAutomatico: '',
            cuentaCredito: '',
            accion: '',
            resultado: '',
            responsable: '',
            carta: '',
            encuesta: '',
            decisiones: ''
          };
          this.rutaCriticaService.eliminarActividad(request).subscribe({
            next: (res) => {
              if (res.success) {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Éxito',
                  detail: 'Actividad eliminada correctamente'
                });
                this.cargarActividades();
              } else {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'Error al eliminar la actividad'
                });
              }
            },
            error: (error) => {
              console.error('Error al eliminar actividad:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar la actividad'
              });
            },
            complete: () => {
              this.loading = false;
            }
          });
        }
      });
    });
  }
} 